import { ExternalLink } from 'lucide-react';

import { Box, Button, Tooltip, Typography } from '@mui/material';

import { WorkspaceAvatar } from './workspace-avatar';
import { Workspace } from '../hooks/use-workspaces';
import { workspacePlanLabel } from '../lib/workspace-utils';

type SoleWorkspaceProps = {
  workspace: Workspace;
  /** Ari Business portal — the same target the switcher menu's Manage rows use. */
  manageUrl: string;
};

export function SoleWorkspace({ workspace, manageUrl }: SoleWorkspaceProps) {
  return (
    <Box
      data-testid="cloud.workspace.sole"
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.25,
        px: 1.25,
        py: 1,
        width: '100%',
        borderRadius: 1.5,
        border: '1px solid',
        borderColor: 'grey.800',
        color: 'grey.50',
      }}
    >
      <WorkspaceAvatar workspace={workspace} />

      <Box sx={{ minWidth: 0, flex: 1, textAlign: 'left' }}>
        <Tooltip title={workspace.shortName} placement="bottom">
          <Typography variant="subtitle2" noWrap sx={{ display: 'block', fontWeight: 700 }}>
            {workspace.shortName}
          </Typography>
        </Tooltip>
        <Typography variant="caption" noWrap sx={{ display: 'block', color: 'text.secondary' }}>
          {workspacePlanLabel(workspace.subscriptionPlan)}
        </Typography>
      </Box>

      <Button
        component="a"
        href={manageUrl}
        target="_blank"
        rel="noopener"
        data-testid="cloud.workspace.manage"
        variant="outlined"
        size="small"
        endIcon={<ExternalLink size={12} />}
        sx={(theme) => ({
          flexShrink: 0,
          height: 24,
          px: 1.25,
          minWidth: 0,
          fontSize: 11,
          fontWeight: 500,
          textTransform: 'none',
          bgcolor: theme.palette.grey[800],
          color: theme.palette.grey[50],
          borderColor: theme.palette.grey[700],
          '&:hover': { bgcolor: theme.palette.grey[700], borderColor: theme.palette.grey[600] },
          '& .MuiButton-endIcon': { ml: 0.5 },
        })}
      >
        Manage
      </Button>
    </Box>
  );
}
